import { Maybe } from "@vixi/types";
import { Category, Subcategory } from "@vixi/types";

export function findCategory(id: Category["id"], categories: Category[]) {
  return (
    categories.reduce<[Maybe<Subcategory>, Maybe<Subcategory>]>(
      (acc, c) => {
        if (acc[0]) {
          return acc;
        }

        if (c.id === id) {
          return [c, undefined];
        }

        const subcategory = c.subCategories.find((sc) => sc.id === id);
        if (subcategory) {
          return [c, subcategory];
        }

        return acc;
      },
      [undefined, undefined],
    ) ?? []
  );
}

export default findCategory;
